<template>
  <div>
    <a :href="`/albumviewPhotostream?id=${item.id}`">
      <div class="album-card card">
        <div class="album-block clearfix">
          <div class="album-thumbnail">
            <div class="album-responsive">
              <div class="album-sizer">
                <div
                  class="album-image"
                  :style="{
                    backgroundImage: 'url(' + `${item.photoImage}` + ')',
                  }"
                ></div>
              </div>
            </div>
            <div class="album-photo-count">
              <span>{{ item.sgL_PG_CPhotoQuantity }}</span>
            </div>
          </div>
        </div>
        <div class="album-info p-3">
          <div class="album-title mb-2" :title="item.sgL_PG_CName">
            {{ item.sgL_PG_CName }}
          </div>
          <span class="album-count"
            >{{$t('Album.albumviewPhotostreamItem.viewcount')}}:{{ item.sgL_PG_CViewQuantity }}</span
          >
          <span class="album-upload-date">{{ item.sgL_PG_CGameDateF }}</span>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    item: { Type: Object },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Album/albumviewPhotostreamItem.vue